import { lsGet, lsSave } from "./localStorage";

// Per-browser navigation preferences for the modern shell (Recent + Favorites).
const RECENT_KEY = "navRecent";
const FAV_KEY = "navFavorites";
const MAX_RECENT = 10;

export const getRecent = () => lsGet(RECENT_KEY) || [];

export const pushRecent = (item) => {
  if (!item?.path) return;
  const list = (lsGet(RECENT_KEY) || []).filter((x) => x.path !== item.path);
  list.unshift({ title: item.title, path: item.path });
  lsSave(RECENT_KEY, list.slice(0, MAX_RECENT));
};

export const getFavorites = () => lsGet(FAV_KEY) || [];

export const isFavorite = (path) =>
  (lsGet(FAV_KEY) || []).some((x) => x.path === path);

export const toggleFavorite = (item) => {
  if (!item?.path) return getFavorites();
  const list = lsGet(FAV_KEY) || [];
  const exists = list.some((x) => x.path === item.path);
  const next = exists
    ? list.filter((x) => x.path !== item.path)
    : [...list, { title: item.title, path: item.path }];
  lsSave(FAV_KEY, next);
  return next;
};
